
interface HeroSectionProps {
  isAdminPanel: boolean;
}

export function HeroSection({ isAdminPanel }: HeroSectionProps) {
  return (
    <section className="bg-gradient-to-r from-green-50 to-green-100 py-16">
      <div className="container mx-auto px-6">
        <div className="text-center">
          <h1 className="text-4xl font-bold font-primary text-gray-800 mb-4">
            {isAdminPanel ? "Painel Administrativo" : "Área do Paciente"}
          </h1>
          <p className="text-xl font-secondary text-gray-600 max-w-3xl mx-auto">
            {isAdminPanel 
              ? "Acesse o painel de controle para gerenciar o sistema"
              : "Acesse sua área exclusiva para acompanhar suas consultas e planos alimentares"
            }
          </p>
        </div>
      </div>
    </section>
  );
}
